import React  from 'react';
import AdminLevelThreeBasicInfoComponent from '../../geo-coverage/admin-level-three/components/admin-level-three-basic';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import AdminLevelFourBasicInfoComponent from './admin-level-four-basic-info';

export const AdminLevelFourComponent = ({handleInnerChange,handleInnerFormChange,selectedCategory,globalAdmin,
 back,handleFormSubmit,parentAdmin,globalAdmin3}: any) => {
  const tabItems=[
    {
        id:1,
        title:'New Admin Level 4',
        component:<AdminLevelFourBasicInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        handleInnerChange={handleInnerChange}
        selectedCategory={selectedCategory}
        globalAdmin={globalAdmin}
        parentAdmin={parentAdmin}
        globalAdmin3={globalAdmin3}
        />,
    isVisible:true,
    }
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default AdminLevelFourComponent;
